<template>
    <v-form ref="form" @submit="submit" v-model="formValid" class="call-configs">
        <!-- Header title -->
        <div class="title-config">
            <div class="title">{{ $f.tc('voiceProfile') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-outline" style="margin-right: 8px" @click="addVoiceSpeed()">
                    <img src="/img/add-blue.svg" style="margin-right: 6px; transform: scale(1.1)">
                    {{ $f.tc('voiceProfile') }}
                </div>
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>

        <!-- Content -->
        <div class="fci-scrollbar config-content">
            <!-- Voice profile -->
            <div class="child-title" style="padding: 0!important;">{{ $f.tc('voiceProfile') }}</div>
            <div style="font-size: 14px; color: #96ADD0; padding-bottom: 20px" v-if="voiceSpeedList.length === 0">
                {{ $f.tc('noDataAvailable') }}
            </div>
            <div v-else style="padding-bottom: 20px">
                <div class="row-config" style="margin-bottom: 6px">
                    <div style="font-weight: 700; font-size: 14px; width: 65%">{{ $f.tc('voice') }}</div>
                    <div style="font-weight: 700; font-size: 14px">{{ $f.tc('speed') }}</div>
                    <div class="config-action"></div>
                </div>
                <div class="row-config" v-for="(voice, index) in voiceSpeedList" :key="index"
                     style="margin-bottom: 6px">
                    <v-select
                        v-model="voice.voice.id"
                        :items="voices"
                        item-value="id"
                        item-text="name"
                        :rules="[formRules.ruleRequired]"
                        class="input-custom"
                        style="margin-right: 7px!important;width: 50%;"
                    >
                    </v-select>
                    <v-text-field
                        v-model="voice.speed"
                        hide-details
                        single-line
                        type="number"
                        min="0.5"
                        max="2"
                        step="0.1"
                        class="input-custom"
                        style="margin-right: 7px!important;width: 15%"
                        @keypress="filterNumber($event)"
                    ></v-text-field>
                    <div class="config-action">
                        <div class="btn-icon" @click="removeVoiceSpeed(index)">
                            <img src="/img/delete-blue.svg" style="transform: scale(1.2); padding-left: 1px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import CampaignService from "@/services/campaign.service";
import {mapState} from "vuex";

export default {
    name: "VoiceProfileInboundConfig",
    mixins: [FormMixin],
    data() {
        return {
            voices: [],
            voiceSpeedList: [],
            voiceProfile: {
                voice: {},
                speed: 1.0,
            },
            voiceProfileMap: {},
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    mounted() {
        if (this.campaign.direction === 'INBOUND') {
            this.getVoices()
            this.getVoiceSpeed()
        }
    },
    methods: {
        submitValidForm() {
            // save voice speed
            this.saveVoiceSpeed()
        },
        getVoiceSpeed() {
            let campaignId = this.campaign.id ? this.campaign.id : this.$route.params.campaignId
            CampaignService.VoiceSpeedService.search(campaignId).then(
                result => {
                    this.voiceSpeedList = result.data
                    // map voice profile
                    result.data.forEach(item => {
                        this.voiceProfileMap[item.id] = item
                    })
                    this.voiceProfileMap = this.$utils.cloneObject(this.voiceProfileMap)
                }
            ).catch(this.$appService.handleRequestError(this.$t('actionFailed', {
                action: 'load',
                item: 'voice speed'
            })))
        },
        addVoiceSpeed() {
            this.voiceSpeedList.push(JSON.parse(JSON.stringify(this.voiceProfile)))
        },
        saveVoiceSpeed() {
            let saveSuccessCount = 0
            let saveFailCount = 0
            let updateSuccessCount = 0
            let updateFailCount = 0
            let noChangeCount = 0
            let oldProfileMap = this.voiceProfileMap
            let finallyFunction = () => {
                if (saveSuccessCount + saveFailCount + updateSuccessCount + updateFailCount + noChangeCount === this.voiceSpeedList.length) {
                    let i18nSave = {
                        action: this.$f.tc('save'),
                        item: this.$t('voiceProfile')
                    }
                    if (saveSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nSave) + ': ' + saveSuccessCount)
                    }
                    if (saveFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nSave) + ': ' + saveFailCount)
                    }
                    let i18nUpdate = {
                        action: this.$f.tc('update'),
                        item: this.$t('voiceProfile')
                    }
                    if (updateSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nUpdate) + ': ' + updateSuccessCount)
                    }
                    if (updateFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nUpdate) + ': ' + updateFailCount)
                    }
                    if (saveFailCount + updateFailCount === 0) {
                        this.getVoiceSpeed()
                    }
                }
            }
            for (let item of this.voiceSpeedList) {
                let model = {
                    voice: item.voice.id,
                    speed: item.speed,
                }
                if (item.id) {
                    // compare old and new
                    let oldItem = oldProfileMap[item.id]
                    if (JSON.stringify(oldItem) === JSON.stringify(item)) {
                        noChangeCount++
                        continue
                    }
                    CampaignService.VoiceSpeedService.update(this.campaign.id, item.id, model).then(
                        () => updateSuccessCount++,
                        () => updateFailCount++
                    ).finally(finallyFunction)
                } else {
                    CampaignService.VoiceSpeedService.create(this.campaign.id, model).then(
                        () => saveSuccessCount++,
                        () => saveFailCount++
                    ).finally(finallyFunction)
                }
            }
        },
        removeVoiceSpeed(index) {
            let item = this.voiceSpeedList[index]
            if (!item.id) {
                this.voiceSpeedList.splice(index, 1)
                return
            }
            // khong xoa item cuoi cung
            if (this.voiceSpeedList.length === 1) {
                this.$appService.toastError(this.$t('actionFailed', {
                    action: this.$f.tc('delete'),
                    item: this.$f.tc('voiceProfile')
                }))
                return
            }
            CampaignService.VoiceSpeedService.delete(this.campaign.id, item.id).then(
                () => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', {
                        action: this.$f.tc('delete'),
                        item: this.$f.tc('voiceProfile')
                    }))
                    this.getVoiceSpeed()
                }).catch(this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$f.tc('delete'),
                    item: this.$f.tc('voiceProfile')
                }))
            )
        },
        getVoices() {
            CampaignService.getVoices().then(
                result => {
                    if (result.data.length) {
                        this.voices = [...result.data]
                        for (let dataKey in result.data) {
                            if (result.data[dataKey]['default']) {
                                this.voiceProfile.voice = result.data[dataKey]
                                break
                            }
                        }
                    }
                    this.$nextTick().then(() => {
                        this.$appService.dataLoading(false)
                        this.$refs.form.resetValidation()
                    })
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: 'load',
                    item: 'voice'
                }))
            )
        },
        filterNumber(evt) {
            let expect = evt.target.value.toString() + evt.key.toString()
            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault()
            } else {
                return true
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
            top: 7px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-input__control {
        width: 100%;
    }
}

.child-title {
    font-size: 16px;
    font-family: 'open sans bold';
    font-weight: 700;
    //border-top: 1px solid #E4EDFA;
    padding-top: 20px;
    margin-bottom: 6px;
}

.title-config {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.label {
    font-family: "open sans semi";
    margin-bottom: 6px;
    font-size: 13px;
}


.row-config {
    display: flex;
    align-items: center;

    .config-repeat, .config-from, .config-to {
        width: 210px;
        margin-right: 8px;
    }

    .config-action {
        width: 28px;
    }
}

.config-content {
    padding: 20px;
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-text-field__details {
            right: 20px;
        }
    }
}

.input-number {
    ::v-deep .v-text-field__details {
        right: 36px !important;
    }
}
</style>
